import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const initial = {
  type: null,
  entryId: null,
  items: [],
  total: 0
}

const getActions = generateActions('comments/FETCH')
const getCountActions = generateActions('comments/FETCH_COUNT')
const addCommentActions = generateActions('comments/ADD')
const addPersonCommentActions = generateActions('personComments/ADD')

export const getComments = createAction(
  API_CONST,
  (entryId, type = 'lots', params = {}) => ({
    params,
    actions: getActions,
    url: `${type}/${entryId}/comments`
  }),
  (entryId, type, params = {}, rewrite = true) => ({ entryId, type, rewrite })
)

export const getCount = createAction(
  API_CONST,
  (entryId, type = 'lots') => ({
    actions: getCountActions,
    url: `${type}/${entryId}/comments/count`
  })
)

export const addComment = createAction(
  API_CONST,
  (entryId, message, type = 'lots') => ({
    method: 'post',
    params: { message },
    actions: addCommentActions,
    url: `${type}/${entryId}/${type === 'lots' ? 'comments/add' : 'comment'}`
  })
)

export const addPersonComment = createAction(
  API_CONST,
  (entryId, message, photos, status) => ({
    method: 'POST',
    params: { message, photos, status},
    actions: addPersonCommentActions,
    url: `lots/${entryId}/personComments/add`
  })
)

export default handleActions({
  [getActions[0]]: (state, { meta }) => meta.rewrite
    ? { ...initial, type: meta.type, entryId: meta.entryId }
    : { ...state },
  [getActions[1]]: (state, { payload = [], meta }) => ({
    ...state,
    items: meta.rewrite ? payload : [ ...state.items, ...payload ]
  }),
  [getCountActions[1]]: (state, { payload }) => ({
    ...state,
    total: payload.value
  }),
  [addCommentActions[1]]: (state, { payload }) => ({
    ...state,
    items: [ payload, ...state.items.slice(0, state.items.length - (state.total === state.items.length ? 0 : 1)) ],
    total: state.total + 1
  }),
  [addPersonCommentActions[1]]: (state, { payload }) => ({
    ...state,
    items: [ payload, ...state.items.slice(0, state.items.length - (state.total === state.items.length ? 0 : 1)) ],
    total: state.total + 1
  })
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/comments/index.js